import React from 'react';
import { Pressable, StyleSheet, Text } from 'react-native';
import { PressableState } from '../PressableStyled';
import Colors from '../../constants/Colors';

interface TabButtonProps {
  onPress: () => void,
  title: string,
  selected: boolean,
  testID?: string,
}

const MapTabButton = ({
  onPress, title, selected, testID,
}: TabButtonProps) => <Pressable
  {...{ onPress, testID }}
  style={({ hovered }: PressableState) => [
    styles.container, hovered && styles.containerHovered, selected && styles.containerSelected,
  ]}
  disabled={selected}
  {...{ testID }}
>
    <Text style={[styles.text, selected && styles.textSelected]}>
      {title}
    </Text>
  </Pressable>;

const styles = StyleSheet.create({
  container: {
    paddingVertical: 4,
    paddingHorizontal: 12,
    borderRadius: 4,
    borderWidth: 1,
    marginHorizontal: 4,
    borderColor: Colors.light.hereworksBlue300,
  },
  containerSelected: {
    backgroundColor: Colors.light.hereworksBlue500,
    borderColor: Colors.light.hereworksBlue500,
  },
  containerHovered: {
    backgroundColor: Colors.light.hereworksBlue50,
    borderColor: 'transparent',
  },
  text: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlue400,
  },
  textSelected: {
    color: '#FFF',
  },
});

export default MapTabButton;
